import { Icons, Typography } from '@flash-tecnologia/hros-web-ui-v2';
import { FC } from 'react';

type FileViwerProps = {
  fileName: string;
};

const FileViwer: FC<FileViwerProps> = ({ fileName }) => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.thumbnail}>
        <div
          style={{
            height: '50px',
            width: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid #EBE6E9',
          }}
        >
          <Icons
            name="IconCheck"
            fill={'var(--color-secondary-light2)'}
            color={'var(--color-secondary-light4)'}
            size={20}
          />
        </div>
      </div>

      <div style={styles.details}>
        <Typography style={{ fontWeight: '600' }} variant="body4">
          {fileName}
        </Typography>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    width: '100%',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    border: '1px solid #EBE6E9',
    borderRadius: '12px',
  },
  thumbnail: {
    flexShrink: 0,
    marginRight: '10px',
  },
  details: {
    flex: 1,
  },
};

export default FileViwer;
